/**
 * Steps da Oficina de Monitoramento e Avaliação
 */

export function getSteps(config) {
  const presencial = config.platform === 'Presencial'
  
  function getCityWithState() {
    if (config.city && config.state) {
      return `${config.city} - ${config.state}`
    }
    return config.city || ''
  }
  
  return [
    {
      title: 'Setup Técnico (Facilitador)',
      icon: 'Settings',
      type: 'technical-setup',
      content: 'Seu Painel de Controle',
      tabs: [
        {
          id: 'whatsapp',
          label: '1. WhatsApp',
          icon: 'QrCode',
          whatsappNumber: config.whatsappNumber,
        },
        {
          id: 'google-meet',
          label: 'Google Meet',
          icon: 'Video',
          items: [
            'Áudio: Verifique se o microfone está funcionando e captando o áudio corretamente.',
            'Vídeo: Confirme se a câmera está ativa e transmitindo sua imagem corretamente.',
            'Volume: Ajuste o volume para garantir que todos possam ouvir claramente.',
          ],
        },
        {
          id: 'suporte',
          label: '3. Suporte',
          icon: 'Users',
          items: [
            'Equipe de Suporte: Confirme que a equipe está online e pronta para atender dúvidas via WhatsApp.',
            'Responsabilidades: Todos os membros estão cientes de suas funções durante a oficina?',
          ],
        },
        {
          id: 'sistemas',
          label: '4. Sistemas',
          icon: 'Settings',
          evaluationLink: config.evaluationLink,
          platform: config.platform,
        },
        {
          id: 'acesso-remoto',
          label: '5. Acesso Remoto',
          icon: 'Monitor',
          sosLink: config.sosLink,
          showOnlyIfNotPresencial: true,
        },
      ],
    },
    {
      title: presencial ? 'Verificação da Sala' : 'Setup da Sala Remota',
      icon: presencial ? 'MapPin' : 'Cast',
      type: 'remote-setup',
      content: presencial 
        ? 'Checklist do Ambiente Presencial'
        : `Alinhamento com ${config.contactName || 'Ponto Focal'}`,
      script: presencial 
        ? 'Você está no comando presencial.'
        : `Olá ${config.contactName || 'colega'}, você me ouve bem? Vamos verificar se a sala está pronta para todos assistirem via Google Meet.`,
      tip: presencial 
        ? 'Garanta que o HDMI e o som da sala estejam conectados corretamente.'
        : 'Guie o ponto focal passo a passo para garantir a qualidade da experiência lá na ponta.',
      tabs: presencial
        ? [
            {
              id: 'projecao',
              label: '1. Projeção',
              icon: 'Monitor',
              sectionTitle: 'Verifique você mesmo:',
              items: [
                {
                  title: 'Cabo HDMI',
                  description: 'O computador está projetando na tela/TV?',
                },
                {
                  title: 'Visibilidade',
                  description: 'O tamanho da letra está legível para quem está no fundo?',
                },
              ],
            },
            {
              id: 'audio-local',
              label: '2. Áudio Local',
              icon: 'Volume',
              sectionTitle: 'Verifique você mesmo:',
              items: [
                {
                  title: 'Conexão da Caixa de Som',
                  description: 'O cabo de áudio está conectado corretamente?',
                },
                {
                  title: 'Teste de Volume',
                  description: 'Teste o microfone ou toque um áudio para garantir que o fundo da sala ouve.',
                },
              ],
            },
          ]
        : [
            {
              id: 'transmissao',
              label: '1. Transmissão',
              icon: 'Cast',
              sectionTitle: `Oriente ${config.contactName || 'Ponto Focal'}:`,
              items: [
                {
                  title: 'Link da Sala',
                  description: 'O link já foi aberto na projeção?',
                },
                {
                  title: 'Visibilidade',
                  description: 'O tamanho da letra está legível para quem está no fundo?',
                },
              ],
            },
            {
              id: 'som-sala',
              label: '2. Som da Sala',
              icon: 'Volume',
              sectionTitle: `Oriente ${config.contactName || 'Ponto Focal'}:`,
              items: [
                {
                  title: 'Conexão da Caixa de Som',
                  description: 'O cabo de áudio está conectado corretamente?',
                },
                {
                  title: 'Teste de Volume',
                  description: 'Teste o microfone ou toque um áudio para garantir que o fundo da sala ouve.',
                },
              ],
            },
            {
              id: 'internet',
              label: '3. Internet',
              icon: 'WiFi',
              sectionTitle: `Oriente ${config.contactName || 'Ponto Focal'} a verificar:`,
              items: [
                {
                  title: 'Conexão do PC',
                  description: 'Peça para verificar se está conectado.',
                  tip: 'Dica: Se possível, usar cabo de rede.',
                },
              ],
            },
            {
              id: 'acesso-remoto-sala',
              label: '4. Acesso Remoto',
              icon: 'Monitor',
              sectionTitle: `Oriente ${config.contactName || 'Ponto Focal'}:`,
              sosLink: config.sosLink,
            },
          ],
    },
    {
      title: 'Saudação e Contextualização',
      icon: 'Users',
      type: 'script',
      content: presencial 
        ? `Olá, pessoas de ${getCityWithState()}! É um prazer estar aqui presencialmente com vocês.\n\nEu sou ${config.facilitatorName || '[Seu Nome]'} e serei o facilitador desta oficina.\n\nO tema do nosso encontro hoje é ${config.theme}.`
        : `Olá, pessoas de ${getCityWithState()}! Sejam muito bem-vindas à nossa Oficina de Monitoramento e Avaliação.\n\nEu sou ${config.facilitatorName || '[Seu Nome]'} e vocês estão acompanhando esta transmissão ao vivo.\n\nO tema da nossa oficina hoje é ${config.theme}.`,
      action: 'Fale com entusiasmo e sorrindo.',
      tip: 'A apresentação pessoal cria conexão imediata.',
    },
    {
      title: presencial ? 'Dinâmica Digital' : 'Formato Híbrido',
      icon: 'Monitor',
      type: 'script',
      content: presencial 
        ? `Apesar de estarmos juntos aqui na sala, vamos exercitar o SUS Digital na prática.\n\nUtilizaremos nossos celulares para interagir, registrar presença e tirar dúvidas através do WhatsApp.\n\nO objetivo é vivenciarmos as ferramentas digitais.`
        : `Estamos falando ao vivo com vocês via ${config.platform}.\n\nA qualquer momento vocês podem nos enviar mensagem via WhatsApp.\n\nTambém podem vir aqui mais perto da tela com a ajuda de ${config.contactName || 'nosso apoio na sala'}, abrir o microfone e conversar com a gente aqui mesmo no ${config.platform}.`,
      action: presencial ? 'Peça para todos pegarem os celulares.' : 'Incentive a interação mista: WhatsApp para texto, Microfone para fala.',
      tip: presencial ? 'Isso justifica o uso do celular em uma reunião presencial.' : 'Garanta que o apoio na sala saiba como ativar o microfone se alguém se aproximar.',
    },
    {
      title: 'Atualização de usuário no eSUS Feedback',
      icon: 'FileText',
      type: 'tabbed-video',
      content: 'Atualização Cadastral',
      tabs: [
        {
          id: 'context',
          label: '1. Importância',
          icon: 'Info',
          content: `Antes de prosseguirmos, peço que cada um atualize o seu cadastro no eSUS Feedback.\n\nAssim, nosso sistema identifica automaticamente que vocês são profissionais de ${getCityWithState()}.`,
          subtext: 'Isso agiliza o atendimento e garante que os certificados/dados sejam gerados corretamente.',
        },
        {
          id: 'video',
          label: '2. Como Fazer (Vídeo)',
          icon: 'Youtube',
          videoId: 'kY_NGb_RcCI',
          tip: 'Aumente o volume se necessário para que todos ouçam o tutorial.',
        },
      ],
    },
    {
      title: 'Canal de Dúvidas & Teste',
      icon: 'MessageCircle',
      type: 'tabbed-interaction',
      content: 'Interação e Teste',
      tabs: [
        {
          id: 'access',
          label: '1. Canais de Suporte',
          icon: 'QrCode',
          content: 'Para interagir, enviem mensagens pelo WhatsApp. \n\n⚠️ Se o WhatsApp não responder, utilizem o Chat Online dentro do aplicativo eSUS Feedback.',
          subtext: presencial 
            ? 'Mesmo eu estando aqui, registrem as dúvidas no canal para que fiquem documentadas e nossa equipe de suporte também possa ajudar.'
            : 'Nossa equipe monitora os dois canais. Dúvidas complexas serão repassadas para eu demonstrar aqui na tela.',
          whatsappNumber: config.whatsappNumber,
        },
        {
          id: 'test',
          label: '2. Teste Rápido',
          icon: 'CheckCircle',
          content: 'Para testar, peço que alguém envie um \'Oi\' para o suporte agora. Vamos confirmar se a equipe já está recebendo.',
          checklistKey: 'msgReceived',
          checklistLabel: 'Suporte confirmou recebimento?',
          action: 'Aguarde o sinal positivo da sua equipe de suporte.',
        },
      ],
      tip: 'Use a aba 2 para validar tecnicamente se as mensagens estão chegando.',
    },
    {
      title: 'Regras de Convivência',
      icon: 'AlertCircle',
      type: 'list',
      content: 'Para fluir bem, vamos combinar:',
      items: [
        'Podem usar o celular à vontade para nos enviar mensagem no WhatsApp',
        'Evitem conversas paralelas de voz para não atrapalhar quem está ouvindo',
        presencial ? 'Se precisarem sair, fiquem à vontade.' : 'Se a imagem travar, aguardem que retoma automático',
      ],
    },
    {
      title: 'Gravação e Transcrição',
      icon: 'Video',
      type: 'script',
      content: 'Queria começar pedindo permissão a vocês para gravar esta reunião.\n\nEssa gravação é restrita aos participantes aqui presentes e tem por objetivo servir de anotações e consulta, caso vocês queiram ela como material de consulta posterior.\n\nVamos combinar assim: vou esperar 1 minuto e meio e se ninguém se manifestar de forma contrária, então entende-se que todos concordam com a gravação.',
      subtext: 'Vocês podem solicitar a gravação ou o texto da transcrição a qualquer momento, inclusive após o término do encontro. Basta pedir pelo WhatsApp.',
      action: 'Inicie a gravação agora.',
      tip: 'Isso gera segurança e permite consulta posterior.',
    },
    {
      title: 'Início do Conteúdo',
      icon: 'Play',
      type: 'script',
      content: `Pronto, sistema ok. Vamos começar, ${getCityWithState()}!`,
      subtext: 'Esta ação atende aos requisitos do SUS DIGITAL (Portaria 3232/2024), contribuindo com: educação permanente; inovação; uso ético de tecnologias; engajamento digital; LGPD; aplicativos móveis e melhoria do Índice de Maturidade em Saúde Digital.',
      action: 'Ressalte: \'O primeiro passo no SUS DIGITAL é experimentar as ferramentas, como estamos fazendo hoje.\'',
      tip: 'Conecte o formato da reunião com a política pública.',
    },
    {
      title: 'SUS Digital',
      icon: 'Globe',
      type: 'tabbed-content',
      content: 'Programa SUS Digital',
      tabs: [
        {
          id: 'aps',
          label: '1. Objetivos APS',
          icon: 'Info',
          content: 'O programa SUS DIGITAL está instituído pela Portaria nº 3232 de março de 2024. O objetivo é usar o meio digital para:',
          list: [
            'Educação permanente para gestores e trabalhadores',
            'Letramento digital (uso correto de ferramentas)',
            'Encontros e reuniões online',
            'Sensibilização e engajamento no uso de ferramentas',
            'Cultura da saúde digital e proteção de dados',
            'Planejamento, monitoramento e avaliação',
            'Inovação em saúde',
          ],
        },
        {
          id: 'targets',
          label: '2. Públicos-Alvo',
          icon: 'Users',
          sections: [
            {
              title: 'Gestores de Saúde',
              text: 'Podem estar mais perto dos cidadãos e facilitar a comunicação com a gestão municipal e profissionais, realizando reuniões sem deslocamento físico.',
            },
            {
              title: 'Trabalhadores de Saúde',
              text: 'Levam mais saúde aos cidadãos e facilitam a comunicação com a gestão municipal e interna, permitindo reuniões à distância.',
            },
            {
              title: 'Cidadãos',
              text: 'Recebem atendimentos e informações sem a necessidade de se deslocarem grandes distâncias.',
            },
          ],
        },
        {
          id: 'challenges',
          label: '3. Desafios',
          icon: 'AlertCircle',
          content: 'Para o SUS DIGITAL atingir seus objetivos, serão necessários:',
          list: [
            'Equipamentos de informática adequados nos consultórios',
            'Sistemas especialistas de M&A',
            'Sistema de comunicação online',
            'Internet de qualidade',
            'Treinamento constante',
          ],
        },
        {
          id: 'toolkit',
          label: '4. Ferramentas',
          icon: 'Wrench',
          content: 'A seguir, apresentamos um conjunto de ferramentas e recursos digitais para ajudar gestores e trabalhadores de saúde no uso e aplicação da saúde digital em seu território.',
        },
      ],
      tip: 'Explique como essas ferramentas impactam o dia a dia da unidade.',
    },
    {
      title: 'Avaliação e Encerramento',
      icon: 'Star',
      type: 'tabbed-evaluation',
      content: 'Feedback e Divulgação',
      tabs: [
        {
          id: 'evaluate',
          label: 'Avaliar',
          icon: 'Star',
          content: 'Avaliação do treinamento',
          subtext: 'Peça para que todos avaliem o treinamento pelo link ou QR Code.',
          evaluationLink: config.evaluationLink,
        },
        {
          id: 'social',
          label: 'Redes Sociais',
          icon: 'Share2',
          content: 'Compartilhem este momento no Instagram e WhatsApp! No SUS fazemos muito e divulgamos pouco; precisamos mostrar nossas boas práticas.',
          subtext: 'Se postarem, não esqueçam de marcar: @biatic e a Secretaria de Saúde.',
          action: 'Vamos fortalecer a imagem do nosso trabalho!',
        },
        {
          id: 'photos',
          label: 'Fotos p/ Divulgação',
          icon: 'Camera',
          content: 'Por favor, tirem fotos da turma reunida e enviem para nós aqui no WhatsApp de suporte.',
          subtext: 'Queremos usar essas imagens para divulgar essa experiência exitosa em nossos canais oficiais.',
          whatsappNumber: config.whatsappNumber,
        },
      ],
    },
    {
      title: 'Agradecimentos Finais',
      icon: 'Heart',
      type: 'facilitator-closing',
      content: 'Gratidão a todos pela participação e engajamento!',
      subtext: 'Encorajo vocês a continuarem utilizando o eSUS Feedback no dia a dia para aplicarem o que aprendemos hoje. A transformação digital começa na rotina de cada um.',
      action: 'Despeça-se calorosamente e encerre o encontro.',
      tip: 'Deixe o canal do WhatsApp aberto por mais alguns minutos para dúvidas finais.',
    },
  ]
}
